import {userService} from '../router'
import {router} from '../backend'

const user = JSON.parse(localStorage.getItem('user'))
const state = user ? { status: { loggedIn: true }, user } : { status: {}, user: null }

const actions = {
  async login ({ dispatch, commit }, { userId, userPw }) {
    commit('loginRequest')
    try {
      const user = await userService.login(userId, userPw)
      commit('loginSuccess', user)
      router.replace('/')
    } catch (error) {
      commit('loginFailure', error)
    }
  },
  logout ({ commit }) {
    userService.logout()
    commit('logout')
  },
  getAll ({ commit }) {
    commit('getAllRequest')
    userService.getAll()
      .then(
        users => commit('getAllSuccess', users),
        error => commit('getAllFailure', error)
      )
  },

  delete ({ commit }, id) {
    commit('deleteRequest', id)

    userService.delete(id)
      .then(user => commit('deleteSuccess', id), error => commit('deleteFailure', { id, error: error.toString() }))
  }
}

const mutations = {
  getAllRequest (state) {
    state.all = { loading: true }
  },
  getAllSuccess (state, users) {
    state.all = { items: users }
    localStorage.setItem('userInfo', JSON.stringify(users.data))
    if (users.data === undefined) {
      router.replace('/login')
    } else {
      if (users.data.userRole === 'ClubManager') {
        router.replace('/HO101')
      }
      if (users.data.userRole === 'AplManager') {
        router.replace('/HO201')
      }
      if (users.data.userRole === 'AplMaster') {
        router.replace('/HO201')
      }
      if (users.data.userRole === 'AplDeveloper') {
        router.replace('/HO201')
      }
      if (users.data.userRole === 'SktDeveloper') {
        router.replace('/HO201')
      }
    }
  },
  getAllFailure (state, error) {
    state.all = { error }
  },
  deleteRequest (state, id) {
    // add 'deleting:true' property to user being deleted
    state.all.items = state.all.items.map(user => user.id === id ? { ...user, deleting: true } : user)
  },
  deleteSuccess (state, id) {
    // remove deleted user from state
    state.all.items = state.all.items.filter(user => user.id !== id)
  },
  deleteFailure (state, { id, error }) {
    // remove 'deleting:true' property and add 'deleteError:[error]' property to user
    state.all.items = state.items.map(user => {
      if (user.id === id) {
        // make copy of user without 'deleting:true' property
        const { deleting, ...userCopy } = user
        // return copy of user with 'deleteError:[error]' property
        return { ...userCopy, deleteError: error }
      }

      return user
    })
  },
  loginRequest (state) {
    state.status = { loggingIn: true }
  },
  loginSuccess (state, user) {
    state.status = { loggedIn: true }
    state.user = user
  },
  loginFailure (state) {
    state.status = {}
    state.user = null
  },
  logout (state) {
    state.status = {}
    state.user = null
    state.users = null
    state.userInfo = null
  },
  setUserInfo (state, user) {
    state.userInfo = user
  }
}

export const users = {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/userActionAndMutations.js